// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AcademicUnit_shadow__s9zt8 {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.AcademicUnit_shadow-margin__reSZr {
  margin-top: 5px;
}

.AcademicUnit_scroll-section__dnk0\\+ {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.AcademicUnit_scroll-section__dnk0\\+::-webkit-scrollbar-track {
  background-color: transparent;
}

.AcademicUnit_scroll-section__dnk0\\+::-webkit-scrollbar {
  width: 7px;
  background-color: transparent;
}

.AcademicUnit_scroll-section__dnk0\\+::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.3);
}

.AcademicUnit_academic-units__66QA9 {
  position: absolute;
  bottom: 20px;
  right: 20px;
  height: 78%;
  width: 75%;
  border-radius: 10px;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_segmented-option__cCuxY {
  display: flex;
  justify-content: center;
  align-items: center;
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_segmented-option__cCuxY svg {
  margin-right: 5px;
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_segmented-option__cCuxY svg path {
  stroke: var(--explore-color);
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_detail-bio__BONS8 {
  padding: 2%;
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_detail-bio__BONS8 .AcademicUnit_unit-actions__vQBH4 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_detail-bio__BONS8 .AcademicUnit_unit-actions__vQBH4 .AcademicUnit_back-button__P5jIn {
  margin-right: 10px;
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_detail-bio__BONS8 .AcademicUnit_filters__zm8zd .AcademicUnit_filter-levels__lg\\+E5 {
  font-size: 12px;
  color: var(--explore-color);
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_e-chart__I48M7 {
  width: 100%;
  height: 100%;
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_e-chart__I48M7 .AcademicUnit_instruction__KCfQi {
  color: var(--dark-grey);
  font-size: 13px;
  display: flex;
  margin: 15px 0 10px 15px;
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_e-chart__I48M7 .AcademicUnit_instruction__KCfQi svg {
  margin-right: 5px;
}
.AcademicUnit_academic-units__66QA9 .AcademicUnit_e-chart__I48M7 .AcademicUnit_instruction__KCfQi svg path {
  stroke: var(--dark-grey);
}
@media only screen and (min-width: 481px) and (max-width: 1025px) {
  .AcademicUnit_academic-units__66QA9 {
    width: 70%;
  }
}
@media only screen and (max-width: 480px) {
  .AcademicUnit_academic-units__66QA9 {
    width: 100%;
    position: relative;
    top: 0;
    right: 0;
  }
  .AcademicUnit_academic-units__66QA9 .AcademicUnit_scroll-section__dnk0\\+ {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }
  .AcademicUnit_academic-units__66QA9 .AcademicUnit_institution-units__NuU0g {
    width: 95%;
  }
  .AcademicUnit_academic-units__66QA9 .AcademicUnit_detail-bio__BONS8 .AcademicUnit_unit-actions__vQBH4 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  .AcademicUnit_academic-units__66QA9 .AcademicUnit_detail-bio__BONS8 .AcademicUnit_unit-actions__vQBH4 .AcademicUnit_back-button__P5jIn {
    margin-bottom: 10px;
  }
}

.AcademicUnit_fade-in__5AjqA {
  animation: AcademicUnit_blurFadeIn__cTZW4 0.3s ease-out forwards;
}

.AcademicUnit_fade-out__\\+Gxbs {
  animation: AcademicUnit_blurFadeOut__Tv3gK 0.3s ease-out forwards;
}

@keyframes AcademicUnit_blurFadeIn__cTZW4 {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes AcademicUnit_blurFadeOut__Tv3gK {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.5);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/AcademicUnit/AcademicUnit.module.scss"],"names":[],"mappings":"AAAA;EACE,yCAAA;AACF;;AACA;EACE,eAAA;AAEF;;AAAA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AAGF;;AADA;EACE,6BAAA;AAIF;;AADA;EACE,UAAA;EACA,6BAAA;AAIF;;AADA;EACE,mBAAA;EACA,0CAAA;AAIF;;AAFA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AAKF;AAJE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAMJ;AALI;EACE,iBAAA;AAON;AANM;EACE,4BAAA;AAQR;AAJE;EACE,WAAA;AAMJ;AALI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAON;AANM;EACE,kBAAA;AAQR;AAJM;EACE,eAAA;EACA,2BAAA;AAMR;AAFE;EACE,WAAA;EACA,YAAA;AAIJ;AAHI;EACE,uBAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AAKN;AAJM;EACE,iBAAA;AAMR;AALQ;EACE,wBAAA;AAOV;AAFE;EAtDF;IAuDI,UAAA;EAKF;AACF;AAJE;EAzDF;IA0DI,WAAA;IACA,kBAAA;IACA,MAAA;IACA,QAAA;EAOF;EANE;IACE,WAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;EAQJ;EANE;IACE,UAAA;EAQJ;EALI;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;EAON;EANM;IACE,mBAAA;EAQR;AACF;;AAFA;EACE,gEAAA;AAKF;;AAHA;EACE,iEAAA;AAMF;;AAHA;EACE;IACE,UAAA;IACA,mBAAA;EAMF;EAJA;IACE,YAAA;IACA,qBAAA;EAMF;EAJA;IACE,UAAA;IACA,mBAAA;EAMF;AACF;AAHA;EACE;IACE,UAAA;IACA,mBAAA;EAKF;EAHA;IACE,YAAA;IACA,qBAAA;EAKF;EAHA;IACE,UAAA;IACA,mBAAA;EAKF;AACF","sourcesContent":[".shadow {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n}\n.shadow-margin {\n  margin-top: 5px;\n}\n.scroll-section {\n  height: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.scroll-section::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.scroll-section::-webkit-scrollbar {\n  width: 7px;\n  background-color: transparent;\n}\n\n.scroll-section::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: rgba($color: #ffffff, $alpha: 0.3);\n}\n.academic-units {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  height: 78%;\n  width: 75%;\n  border-radius: 10px;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  .segmented-option {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    svg {\n      margin-right: 5px;\n      path {\n        stroke: var(--explore-color);\n      }\n    }\n  }\n  .detail-bio {\n    padding: 2%;\n    .unit-actions {\n      display: flex;\n      align-items: center;\n      margin-bottom: 20px;\n      .back-button {\n        margin-right: 10px;\n      }\n    }\n    .filters {\n      .filter-levels {\n        font-size: 12px;\n        color: var(--explore-color);\n      }\n    }\n  }\n  .e-chart {\n    width: 100%;\n    height: 100%;\n    .instruction {\n      color: var(--dark-grey);\n      font-size: 13px;\n      display: flex;\n      margin: 15px 0 10px 15px;\n      svg {\n        margin-right: 5px;\n        path {\n          stroke: var(--dark-grey);\n        }\n      }\n    }\n  }\n  @media only screen and (min-width: 481px) and (max-width: 1025px) {\n    width: 70%;\n  }\n  @media only screen and (max-width: 480px) {\n    width: 100%;\n    position: relative;\n    top: 0;\n    right: 0;\n    .scroll-section {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      overflow: hidden;\n    }\n    .institution-units {\n      width: 95%;\n    }\n    .detail-bio {\n      .unit-actions {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 20px;\n        .back-button {\n          margin-bottom: 10px;\n        }\n      }\n    }\n  }\n}\n\n.fade-in {\n  animation: blurFadeIn 0.3s ease-out forwards;\n}\n.fade-out {\n  animation: blurFadeOut 0.3s ease-out forwards;\n}\n\n@keyframes blurFadeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(0.5);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes blurFadeOut {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(0.5);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shadow": `AcademicUnit_shadow__s9zt8`,
	"shadow-margin": `AcademicUnit_shadow-margin__reSZr`,
	"scroll-section": `AcademicUnit_scroll-section__dnk0+`,
	"academic-units": `AcademicUnit_academic-units__66QA9`,
	"segmented-option": `AcademicUnit_segmented-option__cCuxY`,
	"detail-bio": `AcademicUnit_detail-bio__BONS8`,
	"unit-actions": `AcademicUnit_unit-actions__vQBH4`,
	"back-button": `AcademicUnit_back-button__P5jIn`,
	"filters": `AcademicUnit_filters__zm8zd`,
	"filter-levels": `AcademicUnit_filter-levels__lg+E5`,
	"e-chart": `AcademicUnit_e-chart__I48M7`,
	"instruction": `AcademicUnit_instruction__KCfQi`,
	"institution-units": `AcademicUnit_institution-units__NuU0g`,
	"fade-in": `AcademicUnit_fade-in__5AjqA`,
	"blurFadeIn": `AcademicUnit_blurFadeIn__cTZW4`,
	"fade-out": `AcademicUnit_fade-out__+Gxbs`,
	"blurFadeOut": `AcademicUnit_blurFadeOut__Tv3gK`
};
export default ___CSS_LOADER_EXPORT___;
